import React, { useState } from 'react'
import {
  Button,
  ListItemText,
  Popover,
  MenuItem,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import {
  IntlContext,
  locales,
  translations,
} from 'app/translations/intl-context'
import * as R from 'ramda'
import useLanguage from 'app/components/selector/useLanguage'

const useStyle = makeStyles(() => ({
  text: {
    color: '#3A3A3A',
  },
  icon: {
    color: '#3A3A3A',
  },
}))

function LanguageMenuSwitcher(props) {
  const classes = useStyle(props)
  const { items } = useLanguage()

  const [swichLanguageMenu, setSwichLanguageMenu] = useState(null)
  const closeSwitchLanguageMenu = R.compose(
    setSwichLanguageMenu,
    R.always(null),
  )

  return (
    <IntlContext.Consumer>
      {/* to do arg messages  */}
      {({ locale, switchToLanguage, updateLocalizationLanguage }) => (
        <React.Fragment>
          <Button
            onClick={R.compose(setSwichLanguageMenu, R.prop('currentTarget'))}
          >
            <div className="flex flex-col items-start">
              <Typography
                component="span"
                className={clsx(classes.text, 'normal-case font-600 flex')}
              >
                {R.toUpper(locale)}
              </Typography>
            </div>
          </Button>

          <Popover
            open={Boolean(swichLanguageMenu)}
            anchorEl={swichLanguageMenu}
            onClose={closeSwitchLanguageMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            classes={{
              paper: 'py-8',
            }}
          >
            {Object.keys(locales).map((key) => (
              <MenuItem
                key={key}
                onClick={R.compose(
                  closeSwitchLanguageMenu,
                  switchToLanguage,
                  R.always(key),
                  updateLocalizationLanguage,
                  R.always({ locale: key, items }),
                )}
              >
                <ListItemText
                  className="ltr:pl-0 rtl:pr-0"
                  primary={translations[key].label}
                />
              </MenuItem>
            ))}
          </Popover>
        </React.Fragment>
      )}
    </IntlContext.Consumer>
  )
}

export default LanguageMenuSwitcher
